import React from 'react';
import { Text } from '@nerdwallet/currency/components/Text';

const TUTooltip = () => (
  <Text size="small">VantageScore 3.0 credit score from TransUnion</Text>
);

export default TUTooltip;
